import { S3_BUCKET_URL } from '@/constants';
import { PAYWALL_NOTES } from '@/constants/campaign-notes';
import { useArchetypeCalculation } from '@/hooks/useArchetypeCalculation';
import { webCampaign } from '@/modules/webCampaign';
import { useLayoutSelections } from '@/pages/Onboarding/hooks/useLayoutSelections';
import { useRoleplayRoomGirlImage } from '@/pages/Onboarding/Layouts/OwnAIRoleplayRooms/hooks/useRoleplayRoomGirlImage.ts';
import {
  supportedSexyBodyShapes,
  supportedSexyHairColors,
} from '@/pages/Paywall/Variants/V6/constants';

export const useGirlBackgroundImage = () => {
  const { archetype } = useArchetypeCalculation();
  const backgroundImage = useRoleplayRoomGirlImage(true);
  const { ageGeneration, bodyShape, hairColor } = useLayoutSelections();

  const isCrutchOnly4NsfwGirl =
    webCampaign.setup.paywallNotes.includes(PAYWALL_NOTES.FOUR_NSFW_GIRL) &&
    hairColor &&
    supportedSexyHairColors.includes(hairColor) &&
    bodyShape &&
    supportedSexyBodyShapes.includes(bodyShape);

  if (
    webCampaign.setup.paywallNotes.includes(PAYWALL_NOTES.REAL_GIRLS_PHOTOS_V2)
  ) {
    return `${S3_BUCKET_URL}/paywall/fast-pay-tab/real_girls_photos_v3/${ageGeneration}_${hairColor}_${bodyShape}.png`;
  }

  if (
    webCampaign.setup.paywallNotes.includes(PAYWALL_NOTES.REAL_GIRLS_PHOTOS)
  ) {
    return `${S3_BUCKET_URL}/paywall/fast-pay-tab/real_girls_photos_v2/${ageGeneration}_${hairColor}_${bodyShape}.png`;
  }

  if (
    webCampaign.setup.paywallNotes.includes(PAYWALL_NOTES.ROLEPLAY_ROOM_GIRLS)
  ) {
    return backgroundImage;
  }
  if (
    webCampaign.setup.paywallNotes.includes(PAYWALL_NOTES.ARCHETYPE) ||
    webCampaign.setup.paywallNotes.includes(PAYWALL_NOTES.ARCHETYPE_REAL_PHOTOS)
  ) {
    return archetype.successImage;
  }

  if (webCampaign.setup.paywallImagesVariant === 'v6') {
    if (isCrutchOnly4NsfwGirl) {
      return `../assets/paywall/v6-sexy/${ageGeneration}_${hairColor}_${bodyShape}.png`;
    } else {
      return `${S3_BUCKET_URL}/paywall/v6/${ageGeneration}_${hairColor}_${bodyShape}.png`;
    }
  }

  if (webCampaign.setup.paywallImagesVariant === 'multigender') {
    return `${S3_BUCKET_URL}/paywall/v6/${ageGeneration}_${hairColor}_${bodyShape}.png`;
  }

  if (webCampaign.setup.paywallImagesVariant === 'v6-sexy') {
    return `../assets/paywall/v6-sexy/${ageGeneration}_${hairColor}_${bodyShape}.png`;
  }

  if (webCampaign.setup.paywallImagesVariant === 'skinny_regular_on_bed') {
    return `${S3_BUCKET_URL}/paywall/fast-pay-tab/skinny_regular_on_bed/${ageGeneration}_${hairColor}_${bodyShape}.png`;
  }

  return `${S3_BUCKET_URL}/success-page/one-night-stand/success.png`;
};
